module.exports = __webpack_public_path__ + "static/media/ua.1aeecd60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ua.svg
// module id = 275
// module chunks = 0